<template>
<div class="chapter">
<div class="inner_page">
<p class="half"><a id="page_i"></a><strong>Daddy Grace</strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm01.vue?1cc72d7a